import { render } from "./productReviewForm.vue?vue&type=template&id=1e17b749&ts=true"
import script from "./productReviewForm.vue?vue&type=script&lang=ts"
export * from "./productReviewForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__